// Keys the app owns. Anything else in localStorage belongs to a library
// and is left alone when clearing cached data.
const OWNED_PREFIXES = ["cerp-"];

export function cachedBytes(): number {
  let total = 0;
  try {
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (!key) continue;
      total += key.length + (localStorage.getItem(key)?.length ?? 0);
    }
  } catch {
    return 0;
  }
  return total;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

// Clears app caches without touching the session or the unsent event
// queue — losing either would sign the user out or drop field activity.
export function clearCachedData(keep: string[]): void {
  try {
    const removable = Object.keys(localStorage).filter(
      (key) => OWNED_PREFIXES.some((prefix) => key.startsWith(prefix)) && !keep.includes(key)
    );
    removable.forEach((key) => localStorage.removeItem(key));
  } catch {
    // Storage unavailable (private mode): nothing cached to clear.
  }
}
